export default function Toast({ toast, onClose }) {
  if (!toast) return null;

  const styles = {
    success: 'bg-green-50 border-green-200 text-green-800',
    error:   'bg-red-50 border-red-200 text-red-800',
    warning: 'bg-amber-50 border-amber-200 text-amber-800',
    info:    'bg-blue-50 border-blue-200 text-blue-800',
  };

  const icons = {
    success: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />,
    error:   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />,
    warning: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />,
    info:    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />,
  };

  const iconColors = {
    success: 'text-green-500',
    error:   'text-red-500',
    warning: 'text-amber-500',
    info:    'text-blue-500',
  };

  const type = toast.type || 'success';

  return (
    <div className={`fixed top-4 right-4 z-50 flex items-center space-x-3 px-5 py-3.5 rounded-xl shadow-xl border text-sm font-medium ${styles[type]}`}>
      <svg className={`w-5 h-5 flex-shrink-0 ${iconColors[type]}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        {icons[type]}
      </svg>
      <span>{toast.message}</span>
      <button onClick={onClose} className="ml-1 opacity-50 hover:opacity-100 transition-opacity">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}
